import { useEffect } from 'react';

const getMobileDetect = (userAgent: NavigatorID['userAgent']) => {
    const isSSR = () => typeof window === 'undefined';
    const isMobile = () => Boolean(isPhone());
    const isDesktop = () => Boolean(!isMobile());
    const isPhone = () => Boolean(!isSSR() && window.innerWidth <= 811);
    const isTablet = () =>
        Boolean(
            !isSSR() &&
                window.innerWidth > 811 &&
                window.innerWidth <= 1366 &&
                !userAgent.match(/Mobi/i)
        );

    if (isSSR())
        return {
            isMobile: () => false,
            isDesktop: () => false,
            isTablet: () => false,
        };
    else {
        return {
            isMobile,
            isDesktop,
            isTablet,
        };
    }
};

const useMobileDetect = () => {
    useEffect(() => undefined, []);
    const userAgent =
        typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

    return getMobileDetect(userAgent);
};

export default useMobileDetect;
